import {z} from 'zod';

export enum StorageLocationType {
	BOX = 1004,
	FILE_URL = 1001,
	AMAZON_S3 = 1002,
	AMAZON_GLACIER = 1003,
	AMAZON_S3_BETA = 1005,
}

export const StorageLocationTypeSchema = z.object({
	id: z.number(),
	name: z.string(),
});

export type IStorageLocationType = z.infer<typeof StorageLocationTypeSchema>;
